import { connect } from 'react-redux'
import Footer from './Footer'

import selectTotals from './Selectors/selectTotals'

import onClickEdit from './Handlers/onClickEdit'
import onClickSave from './Handlers/onClickSave'
import onClickCancel from './Handlers/onClickCancel'

const mapStateToProps = (state) => ({
  editing: state.screens.SubInvoice.editing,
  saving: state.screens.SubInvoice.saving,
  totals: selectTotals(state),
})

const actionCreators = {
  onClickEdit,
  onClickSave,
  onClickCancel,
}

export default connect(mapStateToProps, actionCreators)(Footer)
